interface IUXSWindow extends Window {
  UXS?: {
    sendEvent: (name: string) => void;
  };
}

export const sendUXSEvent = (name: string) => {
  if (typeof window !== 'undefined') {
    const uxsWindow = window as IUXSWindow;
    if (uxsWindow.UXS?.sendEvent) {
      uxsWindow.UXS.sendEvent(name);
    }
  }
};
